import { GridColDef } from "@mui/x-data-grid";
import { GridTable } from "../../../../shared/ReusableComponents/GridTable";
import { DateFormatter } from "../../../../shared/utils/DateFormatter";
import { useEffect, useState } from "react";
import { caseRepository } from "../../../../services/caseRepository";
import { useDispatch } from "react-redux";
import {
  hideLoader,
  showLoader,
} from "../../../../store/currentPreferencesSlice";
import moment from "moment";
import { CommonFunctions } from "../../../../shared/utils/CommonFunctions";
import { MedicineType } from "../../../../shared/constants/enums";
import { AppConfigurationHelper } from "../../../../services/AppConfigurationHelper";

export const MedicationHistory = (props: any) => {
  const { caseId, medicationType } = props;
  const [medicationHistoryData, setMedicationHistoryData] = useState<any>([]);
  const dispatch = useDispatch();
  const columns: GridColDef[] = [
    {
      field: "startDate",
      headerName: "Date, Time",
      width: 180,
      sortable: true,

      valueGetter: (value, row) =>
        `${DateFormatter.formatDate(value)}, ${DateFormatter.formatTime(
          moment(row.schedule, "HH:mm:ss").toISOString()
        )}`,
    },
    {
      field: "medicineName",
      headerName: "Medicine",
      width: 180,
      sortable: true,
    },

    {
      field: "dose",
      headerName: "Dose",
      valueGetter: (params, row) => {
        return row.status === true
          ? CommonFunctions.getDisplayValue(row.dose)
          : AppConfigurationHelper.Instance().displayDefaults?.emptyFallback;
      },
    },
    {
      field: "status",
      headerName: "Status",
      valueGetter: (params, row) =>
        row.status === true ? "Administered" : "Not Administered",
    },
    {
      field: "signedBy",
      headerName: "Signed By",
      valueGetter: (params, row) =>
        CommonFunctions.getDisplayValue(row.signedBy),
    },
    {
      field: "counterSignedBy",
      headerName: "Counter Signed By",
      valueGetter: (params, row) => {
        const name = row.counterSignedBy;
        const displayName = CommonFunctions.getDisplayValue(name);
        return displayName ===
          AppConfigurationHelper.Instance().displayDefaults?.emptyFallback
          ? displayName
          : CommonFunctions.formatName(row.counterSignedBy, { suffixKey: "rn" });
      },
    },
  ];
  if (medicationType === MedicineType.REGULAR) {
    columns.splice(4, 0, {
      field: "reason",
      headerName: "Reason",
      valueGetter: (params, row) =>
        row.status === false
          ? CommonFunctions.getDisplayValue(row.reason)
          : AppConfigurationHelper.Instance().displayDefaults?.emptyFallback,
    });
  }

  useEffect(() => {
    if (caseId) {
      dispatch(showLoader());
      caseRepository
        .GetMedicationHistory(caseId)
        .then((result: any) => {
          const res = [...result];
          const filteredResult = res.filter(
            (item) => item.medicineType === medicationType
          );
          setMedicationHistoryData(filteredResult);
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    }
  }, [caseId, dispatch, medicationType]);

  return (
    <GridTable
      rows={medicationHistoryData}
      columns={columns}
      pageSizeOptions={[5, 10, 15]}
      initialPageSize={10}
      showSearchBar={false}
    />
  );
};
